import { createEmbedConsent } from './embedConsent';

// Calendly's scheduling iframe sets non-essential cookies.
export const {
    consented: calendlyEmbedConsented,
    consent: consentToCalendlyEmbed,
    recording: calendlyEmbedConsentRecording,
    failed: calendlyEmbedConsentFailed,
} = createEmbedConsent('calendly');
